﻿export interface SortElement {
     Row: JQuery;
     Value: string;
}

// Vergleich für die Client-Sortierung; Richtung wie Server (asc = OrderBy)
export function compareSortValue(a: string, b: string, direction: string): number {
    const comparer = direction === "asc" ? 1 : -1;
    if (a === b) return 0;
    return (a > b ? 1 : -1) * comparer;
}
